import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['elementToToggle'];

  toggle = (e) => {
    this.elementToToggleTarget.classList.toggle('vesta-display-none');

    if (e.target.classList.contains('fa-chevron-down')) {
      e.target.classList.remove('fa-chevron-down');
      e.target.classList.add('fa-chevron-up');
      return;
    }

    if (e.target.classList.contains('fa-chevron-up')) {
      e.target.classList.remove('fa-chevron-up');
      e.target.classList.add('fa-chevron-down');
    }
  }
}
